<template>
  <el-select
    class="select-primary"
    v-model="value"
    filterable
    remote
    placeholder="Please enter a keyword"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="changeOption($event)"
    @focus="reset()"
  >
    <el-option
      class="select-primary"
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>
<script>
import { Select, Option } from "element-ui";
import axios from "axios";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    isInitialize: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {
      options: [],
      value: [],
      loading: false
    };
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    remoteMethod(query) {
      let type = this.$route.params.type || this.user.type || 'gaa';
      // TBD 怎麼取得si account 
      if (query !== "") {
        this.loading = true;
        let keyword = query;
        let config = {
          url: `${process.env.VUE_APP_APIHOST}/${type}/console/accounts/${keyword}`,
          method: "get"
        };
        axios(config)
          .then(res => {
            this.loading = false;
            this.options = res.data.map(d => {
              return {
                value: d.id,
                shopId: d['shop_id'],//Added by Howard :D
                shopName: d['shop_name'],//Added by Howard :D
                label: d.concatName
              };
            });
          })
          .catch(err => {
            console.log("axios err: ", err);
            this.$message({
              type: "error",
              message: `資料庫忙碌中，請稍候嘗試。`
            });
          });
      } else {
        this.options = [];
      }
    },
    changeOption(event) {
      let accountId = event;
      let option = this.options.find(o => o.value == accountId);
      this.$emit("change-account", option);
    },
    reset() {
      this.value = "";
      this.options = [];
    }
  },
  watch: {
      isInitialize: function(newVal, oldVal) {
          this.value = "";
      }
  }
};
</script>
<style scoped>
/* .reset-this-root {
  all: initial;
  * {
    all: unset;
  }
} */
</style>
